import { useMutation } from "@tanstack/react-query";
import { deleteDriveFiles } from "./driveFiles";

type Variables = {
  fileUrls: string[];
  spaceId: string;
};

export default function useDeleteFilesFromGoogleDrive() {
  return useMutation({
    mutationFn: (variables: Variables) => deleteDriveFiles(variables.fileUrls, variables.spaceId),
  });
}
